import useTranslation from 'next-translate/useTranslation';
import type { FC } from 'react';

import { Translate } from '@core/constant';
import { EColor, ERouting } from '@core/type';

import { LinkTranslatedStyledAsLink } from '../link-translated/LinkTranslatedStyledAsLink';
import { LinkTranslatedProps } from '../link-translated/interface-link-translated';

export const LinkSignIn: FC<LinkTranslatedProps> = ({
  ...props
}: LinkTranslatedProps): JSX.Element => {
  const { t } = useTranslation(Translate.common.LINK);

  return (
    <LinkTranslatedStyledAsLink keyRoute={ERouting.SIGN_IN} color={EColor.ACCENT} {...props}>
      {t('signIn.title')}
    </LinkTranslatedStyledAsLink>
  );
};
